import type { ManagedMcpIntegration } from '../../../../services/mcpService';
import type { McpProviderUiModule } from './types';

const isHubspotIntegration = (integration: ManagedMcpIntegration) => {
  const code = (integration.code || '').toLowerCase();
  const name = (integration.name || '').toLowerCase();
  return code.includes('hubspot') || name.includes('hubspot');
};

export const hubspotProviderUiModule: McpProviderUiModule = {
  providerCode: 'hubspot',
  matches: (integration: ManagedMcpIntegration) => isHubspotIntegration(integration),
  getUiConfig: () => ({
    providerCode: 'hubspot',
    displayName: 'HubSpot',
    supportsDynamicClientRegistration: false,
    requireClientId: true,
    requireClientSecret: true,
    showEndpointOverride: false,
    oauthClientIdLabel: 'HubSpot App Client ID',
    oauthClientSecretLabel: 'HubSpot App Client Secret',
    extraAuthFields: [
      {
        key: 'hubspotWebhookSigningSecret',
        label: 'Webhook signing secret',
        placeholder: 'Client secret from HubSpot Private App → Auth tab',
        helperText: 'Used to verify incoming HubSpot webhook payloads.',
        type: 'password',
      },
    ],
  }),
};
